import $ from 'jquery';

Drupal.behaviors.fileDownload = {
  attach(context) {
    $('.nerivio-image-card-download div.bottom-section a').each(function () {
      $(this).attr("target", "_blank");
    });

    // Replace the ® character with <sup>®</sup> for superscript.
    $('.nerivio-image-card .bottom-section a', context).html(function (index, html) {
      // First remove any existing sup tags around ® symbols
      let cleaned = html.replace(/<sup>®<\/sup>/g, "®");
      // Then apply the sup tags consistently
      return cleaned.replace(/®/g, "<sup>®</sup>");
    });
  },
};
